<template>
	<section class="departments">
		<h2 :data-aos="disableAos ? undefined : 'fade-up'" class="departments__title text-display">{{ props.title }}</h2>
		<div class="departments__container">
			<GlobalDepartmentsMap :scroll="scroll" :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="200" :contact="contact" />
			<GlobalDepartmentsSearchList :scroll="scroll" :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="300" :contact="contact" />
		</div>
	</section>
</template>

<script setup lang="ts">
const props = defineProps<{
	title: string
	contact?: boolean
	disableAos?: boolean
}>()
const scroll = ref(true)
</script>

<style scoped lang="scss" src="./Section.scss"></style>
